import { pushDataTrackerEvent } from 'approot/shared/data-tracker/data-tracker-push';
import {
  ActivitiesComponentType,
  ActivitiesContentType,
  LanguageCodes,
} from 'global/constants';

const EVENT_CATEGORY = 'text-to-speech';
const EVENT_ACTION_PLAY = 'play';

export function ttsPushDataTrackingEvent({
  componentType,
  componentId,
  contentType,
  contentId,
  lang,
}: {
  componentType: ActivitiesComponentType;
  componentId: string;
  contentType: ActivitiesContentType;
  contentId: number;
  lang: LanguageCodes;
}) {
  pushDataTrackerEvent(EVENT_CATEGORY, EVENT_ACTION_PLAY, {
    target_type: componentType,
    target_identifier: componentId,
    content_id: contentId,
    content_type: contentType,
    lang,
  });
}
